import React from 'react';
import { TextInput, required } from 'react-admin';

// Luhn algorithm check
const luhnCheck = (number) => {
  let sum = 0;
  let alt = false;
  const numArr = number.split('').reverse();

  for (const digit of numArr) {
    let d = parseInt(digit, 10);
    if (alt) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
    alt = !alt;
  }

  return sum % 10 === 0;
};

// Validate Saudi ID or Iqama
export const validateSaudiId = (value) => {
  if (!value) return undefined;

  const id = value.toString().trim();

  // Check if exactly 10 digits
  if (!/^\d{10}$/.test(id)) {
    return 'رقم الهوية يجب أن يتكون من 10 أرقام فقط';
  }

  // Check if first digit is 1 or 2
  if (!['1', '2'].includes(id[0])) {
    return 'رقم الهوية يجب أن يبدأ بـ 1 أو 2';
  }

  // Luhn check
  if (!luhnCheck(id)) {
    return 'رقم الهوية غير صحيح';
  }

  return undefined;
};

export const SaudiIdInput = ({ source_name, index, is_required, field_meta }) => {
  const validations = is_required ? [required(), validateSaudiId] : [validateSaudiId];

  return (
    <TextInput
      source={source_name}
      key={index}
      fullWidth
      validate={validations}
      inputProps={{
        inputMode: 'numeric',
        pattern: '[0-9]*',
        maxLength: 10,
      }}
      helperText="أدخل رقم الهوية أو الإقامة (10 أرقام)"
    />
  );
};

export default SaudiIdInput;
